export default function createFolderValidation(folderBody) {
  if (!folderBody.name) return true;
}